{
	"youveReachedThe50Source": "You've reached the 50 source image limit. Please delete or select fewer images to continue."
}
